/* feedback-local:
 *
 * Provide a feedback button
 *
 * See readme.md for further instructions
 *
 * Author: Niels Giesen
 * Copyright 2012, 2018 Berkeley Bridge
 *
 */

import { bb, gt, _ } from "$json";
import { jumplistArg } from "./feedback-jumplist.js";

(function ($) {
  var credentials;

  try {
    credentials = bb.conf.arbitrary["feedback"].credentials;
  } catch (e) {
    // Empty
  } finally {
    if (!credentials) {
      credentials = {
        username: "Feedback",
        password: "Feedback"
      };
    }
  }

  function getCredentials() {
    return $.isPlainObject(credentials)
      ? credentials
      : credentials === "uniqueid"
        ? { uniqueid: bb.getVar("uniqueid") }
        : {}; // Note if we are using cookies, session is still used.
  }

  $(function () {
    gt.addTranslations({
      "Sending feedback encountered an error": {
        nl: "Versturen van feedback mislukt",
        fr: "L'envoi de commentaires a rencontré une erreur",
        de: "Fehler beim Senden von Feedback"
      }
    });

    var $fdbkwidget = $(
      '<div role="button" tabindex="0" id="fdbk-btn" data-when="isLoggedIn" hidden>' +
        '<span class="btn">' +
        _("Feedback") +
        "</span>" +
        "</div>"
    );

    (document.getElementsByTagName("main").length &&
      $("main").append($fdbkwidget)) ||
      $("body").append($fdbkwidget);

    $(document).on("bb:postHandleData", function (event, data) {
      var group;
      if (data && data.userinfo) $fdbkwidget.data("userinfo", data.userinfo);
      if (data && data.groups && data.groups.length) {
        group = data.groups.filter(function (g) {
          return g.current;
        })[0];
        $fdbkwidget.data("nodename", group.name);
        if (data && data.modelname)
          $fdbkwidget.data("modelname", data.modelname);
        if (data && data.modelversion)
          $fdbkwidget.data("modelversion", data.modelversion);
      }
    });

    $(document).keydown(function (ev) {
      if (ev.keyCode === 27) {
        // ESCAPE
        $fdbkwidget.removeClass("active");
        return true;
      }
      return true;
    });

    $fdbkwidget.one("click", function () {
      $fdbkwidget.append(
        '&nbsp;<span class="p-fdbk-btn-nostyle"' +
          ' id="fdbk-exit" role="button" tabindex="0">×</span>'
      );
      $fdbkwidget.append(
        '<div id="fdbk-if"><p><strong>' +
          _("describe the problem") +
          "</strong></p>" +
          '<textarea id="fdbk"></textarea><br/><br/>' +
          "<p>" +
          _("Please do not collate issues.") +
          "</p>" +
          "<p>" +
          _(
            "Please send only feedback about the" +
              " currently visible question or questions; " +
              "information about these will be" +
              " sent back to the developers."
          ) +
          "</p>" +
          '<button value="send">' +
          _("send") +
          "</button>" +
          "</div>"
      );
      $("#fdbk-btn button").click(fdbkSubmit);
    });

    function show() {
      $fdbkwidget.addClass("active").find("#fdbk").focus();
      $("#fdbk-if, #fdbk-exit").prop("hidden", false);
    }

    function hide() {
      $fdbkwidget.removeClass("active").focus();
      $("#fdbk-if, #fdbk-exit").prop("hidden", true);
      return false;
    }

    $(document).on("click", "#fdbk-btn", show).on("click", "#fdbk-exit", hide);

    function fdbkNotify(data) {
      $("#fdbk").val("");
      if (data && data.sessionid) bb.notify(_("Thanks for your feedback!"));
      else {
        bb.notify(_("Sending feedback encountered an error"));
      }
      $fdbkwidget.removeClass("active");
    }

    function fdbkSubmit() {
      if ($.trim($("#fdbk").val()) !== "")
        $.getJSON(
          "open?",
          $.extend({}, getCredentials(), {
            "modelname": "Feedback",
            "fmt": "json",
            "fdbk:j": jumplistArg(),
            "fdbk:f": $("#fdbk").val().split(/\n/).join("\\n"),
            "fdbk:n": $fdbkwidget.data("nodename"),
            "fdbk:u": $fdbkwidget.data("userinfo")
              ? $fdbkwidget.data("userinfo")["fullname"]
              : "",
            "fdbk:m": $fdbkwidget.data("modelname"),
            "fdbk:v": bb.getVar("version") && bb.getVar("version").join("."),
            "fdbk:a":
              [
                bb.getVar("replyserveraddress"),
                bb.getVar("replyserverport")
              ].join(":") +
              "/" +
              bb.getVar("proxyredirect"),
            "fdbk:s": bb.getVar("sessionid"),
            "fdbk:d": location.href.replace(/(password=)(?:[^&]+)/, "$1***"),
            "fdbk:b": navigator.userAgent
          }),
          fdbkNotify
        );
      $fdbkwidget.focus();
      return false;
    }
  });
})(jQuery);
